import ReportRecord from '@/orm/models/ReportRecord'
import { get } from 'lodash'

export default {
  props: {
    report: {
      type: ReportRecord
    }
  },
  computed: {
    /**
     * Identifies if the report is loaded
     * @return boolean
     */
    reportLoaded () {
      return this.report && this.report.results_generated != null
    },
    /**
     * @return array
     */
    reportResults () {
      return Object.values(get(this, 'report.results') || {})
    },
    /**
     * Get the timezone that the report is operating under.
     */
    timezone () {
      return get(this.report, 'parameters.timezone')
    }
  }
}
